import React, { Suspense } from 'react';
import AppLoading from "../components/AppLoading";
import { Text, Layout } from "../components/native";
import wrapComponent from "./wrapComponent";
import useForwardRef from "../hooks/useForwardRef";
import * as R from 'unitx/ramda';
import { enableScreens } from 'react-native-screens';
import { ActionSheet } from "../@/ActionSheet"; // import {
//   NavigationContainer, wrapHistoryAPI,
// } from '../components/Navigator'

import Toast, { ToastContainer } from "../components/Toast";
import { ScreenClassProvider } from 'react-grid-system';
import KittenApplicationProvider from "./KittenApplicationProvider"; // import { ScreenClassProvider } from '@components/Responsive/grid'

import { SettingsProvider // useSettings,  setAlertContainer,
} from "./settings";
enableScreens();

function ProviderElement(props, forwardedRef) {
  const {
    startAsync,
    onError,
    onFinish,
    image,
    animations,
    mapping,
    theme,
    children
  } = props;
  return R.ifElse(R.allPass([R.propEq('isLoading', true), R.propEq('skipLoadingScreen', false)]), R.always( /*#__PURE__*/React.createElement(AppLoading, {
    startAsync: startAsync,
    onError: onError,
    onFinish: onFinish,
    image: image
  })), R.always( /*#__PURE__*/React.createElement(SettingsProvider, {
    animations: animations,
    theme: theme
  }, /*#__PURE__*/React.createElement(KittenApplicationProvider, {
    ref: forwardedRef,
    mapping: mapping,
    theme: theme
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Text, null, "Loading...")
  }, /*#__PURE__*/React.createElement(ProviderReady, {
    ref: forwardedRef
  }, children))))))(props);
}

const ProviderReady = wrapComponent(({
  children
}, forwardedRef) => {
  // const navigationContainerRef = React.useRef<typeof NavigationContainer>(null)
  const toastRef = React.useRef(null);
  useForwardRef(forwardedRef, {}, () => ({// @ts-ignore
    // navigation: wrapHistoryAPI(navigationContainerRef?.current?.history),
  }));
  React.useEffect(() => Toast.setInstance(toastRef.current));
  return /*#__PURE__*/React.createElement(ActionSheet.ActionSheetProvider, null, /*#__PURE__*/React.createElement(ScreenClassProvider, null, /*#__PURE__*/React.createElement(Layout, {
    style: {
      width: '100%',
      height: '100%'
    }
  }, children, /*#__PURE__*/React.createElement(ToastContainer // @ts-ignore
  , {
    ref: toastRef
  }))));
}, {
  isForwardRef: true
});
export const Provider = wrapComponent(ProviderElement, {
  isForwardRef: true
});